function init_abo_landingpage() {
     var aboContentBox = document.getElementById('aboContentBlock'),
         aboButton = document.querySelectorAll('.box-wrapper button');
         aboLink = document.querySelectorAll('.links-container-link');

    if ( aboContentBox == null ) { return; }

    if ( aboButton != null && aboButton.length >= 1 ) {
        for(i = 0; i < aboButton.length; i++){
            aboButton[i].addEventListener('click', function () {
                changeAboContent($(this).data('abo'), aboContentBox, true);
            });
        }
    }
    if( aboLink != null && aboLink.length >= 1) {
        for(i = 0; i < aboLink.length; i++) {
            aboLink[i].addEventListener('click', function () {
                if(typeof $(this).data('abo') !== 'undefined'){
                    changeAboContent($(this).data('abo'), aboContentBox, true);
                }
            });
        }
    }

    $('#aboContentBlock').css('display', 'flex');
    $('.abo-service-nojs').hide();
}

if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", init_abo_landingpage, false);
} else {
    window.onload = function () {
        init_abo_landingpage();
    };
}
